import React from 'react';
import { ensureReadableColor } from '../utils/colorUtils';

/**
 * X button SVG icon - filled circle with X cutout
 */
const RemoveIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zM5.47 5.47a.75.75 0 011.06 0L8 6.94l1.47-1.47a.75.75 0 111.06 1.06L9.06 8l1.47 1.47a.75.75 0 11-1.06 1.06L8 9.06l-1.47 1.47a.75.75 0 01-1.06-1.06L6.94 8 5.47 6.53a.75.75 0 010-1.06z"/>
  </svg>
);

/**
 * TagPill Component
 * 
 * Renders a single tag as a colored pill with optional remove button.
 */
const TagPill = ({
  tag,
  isPrimary = false,
  onClick,
  onRemove,
  title,
}) => {
  const handleRemoveClick = (e) => {
    e.stopPropagation();
    onRemove?.(tag.name);
  };

  return (
    <span 
      className={`tags-picker__pill ${isPrimary ? 'tags-picker__pill--primary' : ''}`}
      style={{ '--pill-color': ensureReadableColor(tag.color) }}
      onClick={onClick}
      title={title}
    >
      <span className="tags-picker__pill-name">{tag.name}</span>
      <button
        className="tags-picker__pill-x"
        onClick={handleRemoveClick}
        title="Remove"
      >
        <RemoveIcon />
      </button>
    </span>
  );
};

export default TagPill;

